/* Podcast Hub — Dynamic: fetches podcast-episodes.json, renders cards,
   then initialises carousel arrows, category filter, search, show more,
   and the full-screen "Now Playing" audio player overlay */
(function () {
  'use strict';

  /* ---- HERO REEL — duplicate items for infinite scroll ---- */
  var reelTrack = document.querySelector('.podcast-hub__hero-reel-track');
  if (reelTrack) {
    var reelItems = reelTrack.innerHTML;
    reelTrack.innerHTML = reelItems + reelItems;
  }

  /* ---- Globals from Liquid ---- */
  var DATA_URL = window.__podcastDataUrl;
  var DATA_URL_FULL = window.__podcastDataUrlFull;
  var CARD_IMG = window.__podcastCardImg || '';
  var COUNTRY  = window.__countryName || 'the United States';

  /* Lazy-load state */
  var fullDataLoaded = false;
  var fullDataLoading = false;
  var fullDataCallbacks = [];
  var fullCategories = null;

  if (!DATA_URL) {
    console.warn('Podcast Hub: No data URL found (window.__podcastDataUrl). Episodes will not load.');
    return;
  }

  /* ---- Helpers ---- */
  function escapeHtml(str) {
    return str.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/"/g, '&quot;');
  }

  function escapeAttr(str) {
    return (str || '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  /* Valid category labels — must match the filter bubbles */
  var VALID_CATS = {
    'hormones': 'Hormones',
    'digestion': 'Digestion',
    'metabolic-health': 'Metabolic',
    'heart-cardiovascular': 'Heart',
    'brain-memory': 'Brain',
    'weight-metabolism': 'Metabolism',
    'immune-inflammation': 'Immune',
    'womens-health': 'Women'
  };

  /** Format overlay title — highlight the topic/symptom portion */
  function formatOverlayTitle(title) {
    if (!title) return '';
    /* Split at colon — topic before, subtitle after */
    var colonIdx = title.indexOf(':');
    if (colonIdx > 0 && colonIdx < title.length - 1) {
      var topic = title.substring(0, colonIdx).trim();
      var rest = title.substring(colonIdx + 1).trim();
      return '<span class="podcast-hub__overlay-topic">' + topic + '</span>' +
             '<span class="podcast-hub__overlay-subtitle">' + rest + '</span>';
    }
    /* Split at en-dash or em-dash */
    var dashMatch = title.match(/^(.+?)\s*[\u2013\u2014\u2015–—]\s*(.+)$/);
    if (dashMatch) {
      return '<span class="podcast-hub__overlay-topic">' + dashMatch[1].trim() + '</span>' +
             '<span class="podcast-hub__overlay-subtitle">' + dashMatch[2].trim() + '</span>';
    }
    /* No split — show whole title as topic */
    return '<span class="podcast-hub__overlay-topic">' + title + '</span>';
  }

  function getCatLabel(cats, isQa) {
    if (cats && cats.length) {
      for (var i = 0; i < cats.length; i++) {
        if (VALID_CATS[cats[i]]) return VALID_CATS[cats[i]];
      }
    }
    if (isQa) return 'Q&amp;A';
    return '';
  }

  /** Build a latest-grid card (includes date) */
  function buildGridCard(ep, hidden, idx) {
    var epStr = ep.ep ? 'Ep. ' + ep.ep : '';
    var title = escapeHtml(ep.title);
    var cats  = (ep.cats || []).join(' ');
    var catLabel = getCatLabel(ep.cats, ep.qa);
    var cls   = 'podcast-hub__card' + (hidden ? ' podcast-hub__card--hidden' : '');
    var audio = ep.audio || '';
    var desc  = escapeAttr((ep.desc || '').substring(0, 500));
    var meta  = 'Dr. Martin' + (epStr ? ' \u2022 ' + epStr : '');
    var overlay = (typeof idx === 'number' && idx < 12) ? '<span class="podcast-hub__card-overlay-title">' + formatOverlayTitle(title) + '</span>' : '';
    var catTag = catLabel ? '<span class="podcast-hub__cat-tag">' + catLabel + '</span>' : '';

    return '<a role="button" class="' + cls + '" data-episode data-categories="' + cats + '" data-audio="' + escapeHtml(audio) + '" data-title="' + title + '" data-meta="' + escapeAttr(meta) + '" data-desc="' + desc + '" data-ep="' + (ep.ep || '') + '">' +
      '<div class="podcast-hub__card-thumb">' +
        '<img src="' + CARD_IMG + '" alt="" loading="lazy" width="400" height="400">' +
        overlay +
        '<span class="podcast-hub__play-btn"><svg width="14" height="16" viewBox="0 0 14 16" fill="#fff"><path d="M0 0l14 8-14 8z"/></svg></span>' +
      '</div>' +
      '<div class="podcast-hub__card-body">' +
        catTag +
        '<p class="podcast-hub__card-meta">Dr. Martin &bull; <span class="podcast-hub__ep-number">' + epStr + '</span> &bull; ' + (ep.date || '') + '</p>' +
      '</div></a>';
  }

  /** Build a carousel card (no date) */
  function buildCarouselCard(ep) {
    var badge = ep.qa ? 'Q&amp;A' : 'Podcast';
    var epStr = ep.ep ? 'Ep. ' + ep.ep : '';
    var title = escapeHtml(ep.title);
    var audio = ep.audio || '';
    var desc  = escapeAttr((ep.desc || '').substring(0, 500));
    var meta  = 'Dr. Martin' + (epStr ? ' \u2022 ' + epStr : '');

    return '<a role="button" class="podcast-hub__card" data-audio="' + escapeHtml(audio) + '" data-title="' + title + '" data-meta="' + escapeAttr(meta) + '" data-desc="' + desc + '" data-ep="' + (ep.ep || '') + '">' +
      '<div class="podcast-hub__card-thumb">' +
        '<img src="' + CARD_IMG + '" alt="" loading="lazy" width="400" height="400">' +
        '<span class="podcast-hub__card-overlay-title">' + formatOverlayTitle(title) + '</span>' +
        '<span class="podcast-hub__play-btn"><svg width="14" height="16" viewBox="0 0 14 16" fill="#fff"><path d="M0 0l14 8-14 8z"/></svg></span>' +
      '</div>' +
      '<div class="podcast-hub__card-body">' +
        '<p class="podcast-hub__card-meta">Dr. Martin &bull; <span class="podcast-hub__ep-number">' + epStr + '</span></p>' +
      '</div></a>';
  }

  /** Build a full carousel row */
  function buildRow(key, label, subtitle, episodes, numbered) {
    var carouselClass = 'podcast-hub__carousel' + (numbered ? ' podcast-hub__carousel--numbered' : '');
    var cards = '';
    for (var i = 0; i < episodes.length; i++) {
      cards += buildCarouselCard(episodes[i]);
    }

    return '<div class="podcast-hub__row" data-category="' + escapeHtml(key) + '">' +
      '<h2 class="podcast-hub__row-title">' + label + ' <span>&mdash; ' + escapeHtml(subtitle) + '</span></h2>' +
      '<div class="podcast-hub__carousel-wrap">' +
        '<button class="podcast-hub__arrow podcast-hub__arrow--left" aria-label="Scroll left">&#8249;</button>' +
        '<div class="' + carouselClass + '" data-carousel>' + cards + '</div>' +
        '<button class="podcast-hub__arrow podcast-hub__arrow--right" aria-label="Scroll right">&#8250;</button>' +
      '</div>' +
    '</div>';
  }

  /* ---- Lazy-load full dataset ---- */
  function loadFullData(callback) {
    if (fullDataLoaded) { callback(); return; }
    if (callback) fullDataCallbacks.push(callback);
    if (fullDataLoading) return;
    if (!DATA_URL_FULL) { callback(); return; }

    fullDataLoading = true;
    fetch(DATA_URL_FULL)
      .then(function (res) { return res.json(); })
      .then(function (data) {
        allLatest = data.latest || [];
        fullCategories = data.categories || {};
        fullDataLoaded = true;
        fullDataLoading = false;

        /* Re-render carousels with full category data */
        renderCarouselRows(allLatest, fullCategories);
        initCarousels();

        /* Run any queued callbacks (e.g. pending search) */
        var cbs = fullDataCallbacks.splice(0);
        for (var i = 0; i < cbs.length; i++) cbs[i]();
      })
      .catch(function (err) {
        console.error('Podcast Hub: Failed to load full episode data', err);
        fullDataLoading = false;
      });
  }

  /* ---- Fetch & Render ---- */
  fetch(DATA_URL)
    .then(function (res) { return res.json(); })
    .then(function (data) {
      initialEpisodeCount = (data.latest || []).length;
      totalAvailable = data.total_available || initialEpisodeCount;
      renderLatestGrid(data.latest || []);
      renderCarouselRows(data.latest || [], data.categories || {});
      initCarousels();
      initCategoryFilter();
      initSearch();
    })
    .catch(function (err) {
      console.error('Podcast Hub: Failed to load episode data', err);
    });

  /* ---- Render: Latest Episodes Grid with Pagination ---- */
  var PER_PAGE = 12; /* 4 rows x 3 cols desktop */
  var allLatest = [];
  var filteredLatest = [];
  var currentPage = 1;
  var initialEpisodeCount = 0;
  var totalAvailable = 0;

  function renderLatestGrid(latest) {
    allLatest = latest;
    filteredLatest = latest;
    currentPage = 1;
    renderPage();
    initGridSearch();
  }

  function renderPage() {
    var grid = document.getElementById('podcast-hub-latest-grid');
    if (!grid) return;

    var totalPages = Math.ceil(filteredLatest.length / PER_PAGE);
    if (currentPage > totalPages) currentPage = totalPages;
    if (currentPage < 1) currentPage = 1;

    var start = (currentPage - 1) * PER_PAGE;
    var end = Math.min(start + PER_PAGE, filteredLatest.length);

    /* If user is on the last 2 pages of the initial set and more exist, lazy-load */
    if (!fullDataLoaded && totalAvailable > initialEpisodeCount && currentPage >= totalPages - 1) {
      loadFullData(function () {
        filteredLatest = allLatest;
        renderPage();
      });
    }

    var html = '';
    for (var i = start; i < end; i++) {
      html += buildGridCard(filteredLatest[i], false, i);
    }
    grid.innerHTML = html;
    renderPagination(totalPages);
  }

  function renderPagination(totalPages) {
    var nav = document.getElementById('podcast-hub-pagination');
    if (!nav) return;

    if (totalPages <= 1) { nav.innerHTML = ''; return; }

    var html = '';
    /* Prev arrow */
    html += '<button class="podcast-hub__page-btn podcast-hub__page-btn--arrow"' +
      (currentPage <= 1 ? ' disabled' : '') +
      ' data-page="' + (currentPage - 1) + '" aria-label="Previous page">&#8249;</button>';

    /* Page numbers */
    for (var p = 1; p <= totalPages; p++) {
      var active = p === currentPage ? ' podcast-hub__page-btn--active' : '';
      html += '<button class="podcast-hub__page-btn' + active + '" data-page="' + p + '">' + p + '</button>';
    }

    /* Next arrow */
    html += '<button class="podcast-hub__page-btn podcast-hub__page-btn--arrow"' +
      (currentPage >= totalPages ? ' disabled' : '') +
      ' data-page="' + (currentPage + 1) + '" aria-label="Next page">&#8250;</button>';

    nav.innerHTML = html;

    /* Bind clicks */
    nav.querySelectorAll('.podcast-hub__page-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var page = parseInt(btn.getAttribute('data-page'), 10);
        if (isNaN(page) || page === currentPage || btn.disabled) return;
        currentPage = page;
        renderPage();
      });
    });
  }

  function initGridSearch() {
    var input = document.getElementById('podcast-hub-grid-search');
    if (!input) return;
    var timer;
    input.addEventListener('input', function () {
      clearTimeout(timer);
      timer = setTimeout(function () {
        var q = input.value.toLowerCase().trim();
        if (!q) {
          filteredLatest = allLatest;
          currentPage = 1;
          renderPage();
          return;
        }

        /* Load full dataset before searching so we search all episodes */
        function doSearch() {
          filteredLatest = allLatest.filter(function (ep) {
            return (ep.title || '').toLowerCase().indexOf(q) !== -1 ||
                   (ep.desc || '').toLowerCase().indexOf(q) !== -1 ||
                   (String(ep.ep) || '').indexOf(q) !== -1;
          });
          currentPage = 1;
          renderPage();
        }

        if (!fullDataLoaded && totalAvailable > initialEpisodeCount) {
          loadFullData(doSearch);
        } else {
          doSearch();
        }
      }, 250);
    });
  }

  /* ---- Render: Carousel Rows ---- */
  function renderCarouselRows(latest, categories) {
    var container = document.getElementById('podcast-hub-rows');
    if (!container) return;

    var html = '';

    /* Top 10 — first 10 non-Q&A latest episodes */
    var top10 = [];
    for (var i = 0; i < latest.length && top10.length < 10; i++) {
      if (!latest[i].qa) top10.push(latest[i]);
    }
    if (top10.length) {
      html += buildRow(
        'trending',
        'Top 10 in ' + escapeHtml(COUNTRY),
        "What's trending this week",
        top10,
        true
      );
    }

    /* Category order */
    var catOrder = [
      'hormones', 'digestion', 'metabolic-health', 'heart-cardiovascular',
      'brain-memory', 'weight-metabolism', 'immune-inflammation', 'womens-health', 'qa'
    ];

    var rowCount = 0;
    for (var c = 0; c < catOrder.length; c++) {
      var key = catOrder[c];
      var cat = categories[key];
      if (!cat || !cat.episodes || !cat.episodes.length) continue;
      html += buildRow(key, cat.label, cat.subtitle, cat.episodes, false);
      rowCount++;

      /* Quizzes after 3rd category row */
      if (rowCount === 3) {
        var qi = window.__quizIcons || {};
        html += '<div class="podcast-hub__inline-quizzes">' +
          '<a href="/pages/start-here-quiz" class="podcast-hub__iq-card">' +
            '<span class="podcast-hub__iq-icon"><img src="' + (qi.health || '') + '" alt="Health" width="44" height="44" loading="lazy"></span>' +
            '<h3 class="podcast-hub__iq-title">What Stage of Health Are You In?</h3>' +
            '<span class="podcast-hub__iq-btn">Take the Quiz &rarr;</span></a>' +
          '<a href="/pages/thyroid-speed-score-quiz" class="podcast-hub__iq-card podcast-hub__iq-card--blue">' +
            '<span class="podcast-hub__iq-icon"><img src="' + (qi.thyroid || '') + '" alt="Thyroid" width="44" height="44" loading="lazy"></span>' +
            '<h3 class="podcast-hub__iq-title">Is Your Thyroid Slow?</h3>' +
            '<span class="podcast-hub__iq-btn">Take the Quiz &rarr;</span></a>' +
          '<a href="/pages/cortisol-quiz" class="podcast-hub__iq-card">' +
            '<span class="podcast-hub__iq-icon"><img src="' + (qi.cortisol || '') + '" alt="Cortisol" width="44" height="44" loading="lazy"></span>' +
            '<h3 class="podcast-hub__iq-title">Is Your Cortisol Too High?</h3>' +
            '<span class="podcast-hub__iq-btn">Take the Quiz &rarr;</span></a>' +
        '</div>';
      }

      /* Sleek trust bar after 6th category row */
      if (rowCount === 6) {
        var starSvg = '<svg class="podcast-hub__it-star" viewBox="0 0 20 20" fill="currentColor"><path d="M10 1.5l2.47 5.01 5.53.8-4 3.9.94 5.49L10 14.26 5.06 16.7l.94-5.49-4-3.9 5.53-.8L10 1.5z"/></svg>';
        html += '<div class="podcast-hub__inline-trust">' +
          '<div class="podcast-hub__it-inner">' +
            '<span class="podcast-hub__it-stars">' + starSvg + starSvg + starSvg + starSvg + starSvg + '</span>' +
            '<span class="podcast-hub__it-divider"></span>' +
            '<span class="podcast-hub__it-text">Trusted by <strong>142,256+</strong> Customers</span>' +
            '<span class="podcast-hub__it-divider"></span>' +
            '<a href="/collections/all" class="podcast-hub__it-btn">Shop Formulas &rarr;</a>' +
          '</div>' +
        '</div>';
      }
    }

    container.innerHTML = html;
  }

  /* ---- Init: Carousel arrow navigation ---- */
  function updateArrows(carousel, left, right) {
    var scrollLeft = carousel.scrollLeft;
    var maxScroll = carousel.scrollWidth - carousel.clientWidth;
    left.style.opacity = scrollLeft <= 5 ? '0' : '1';
    left.style.pointerEvents = scrollLeft <= 5 ? 'none' : 'auto';
    right.style.opacity = scrollLeft >= maxScroll - 5 ? '0' : '1';
    right.style.pointerEvents = scrollLeft >= maxScroll - 5 ? 'none' : 'auto';
  }

  function initCarousels() {
    document.querySelectorAll('.podcast-hub__carousel-wrap').forEach(function (wrap) {
      var carousel = wrap.querySelector('[data-carousel]');
      var left = wrap.querySelector('.podcast-hub__arrow--left');
      var right = wrap.querySelector('.podcast-hub__arrow--right');
      var scrollAmount = 540;

      if (left && right && carousel) {
        left.style.transition = 'opacity 0.2s';
        right.style.transition = 'opacity 0.2s';
        updateArrows(carousel, left, right);

        carousel.addEventListener('scroll', function () {
          updateArrows(carousel, left, right);
        });

        /* Let vertical scrolling pass through to the page */
        carousel.addEventListener('wheel', function (e) {
          if (Math.abs(e.deltaY) > Math.abs(e.deltaX)) {
            e.preventDefault();
            window.scrollBy(0, e.deltaY);
          }
        }, { passive: false });

        left.addEventListener('click', function () {
          carousel.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
        });
        right.addEventListener('click', function () {
          carousel.scrollBy({ left: scrollAmount, behavior: 'smooth' });
        });
      }
    });
  }

  /* ---- Init: Category filter nav ---- */
  function initCategoryFilter() {
    var nav = document.getElementById('podcast-hub-nav');
    if (!nav) return;

    var buttons = nav.querySelectorAll('.podcast-hub__nav-btn');
    var rows = document.querySelectorAll('.podcast-hub__row');
    var latestSection = document.getElementById('podcast-hub-latest');

    buttons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        buttons.forEach(function (b) { b.classList.remove('active'); });
        btn.classList.add('active');

        var filter = btn.getAttribute('data-filter');

        /* "Latest" scrolls to the grid */
        if (filter === 'latest') {
          if (latestSection) {
            var fb = document.querySelector('.podcast-hub__filter-bar');
            var off = fb ? fb.offsetHeight + 8 : 0;
            var t = latestSection.getBoundingClientRect().top + window.pageYOffset - off;
            window.scrollTo({ top: t, behavior: 'smooth' });
          }
          rows.forEach(function (row) { row.classList.remove('hidden'); });
          if (latestSection) latestSection.style.display = '';
          return;
        }

        /* Show/hide rows */
        rows.forEach(function (row) {
          if (filter === 'all' || row.getAttribute('data-category') === filter) {
            row.classList.remove('hidden');
          } else {
            row.classList.add('hidden');
          }
        });

        /* Show/hide latest grid based on filter */
        if (latestSection) {
          latestSection.style.display = filter === 'all' ? '' : 'none';
        }

        /* Clear search */
        var searchInput = document.getElementById('podcast-hub-search');
        if (searchInput) searchInput.value = '';

        /* Reset card visibility in carousels */
        document.querySelectorAll('.podcast-hub__rows .podcast-hub__card').forEach(function (card) {
          card.style.display = '';
        });

        /* Scroll to first visible row */
        if (filter !== 'all') {
          var target = document.querySelector('.podcast-hub__row[data-category="' + filter + '"]');
          if (target) {
            var filterBar = document.querySelector('.podcast-hub__filter-bar');
            var offset = filterBar ? filterBar.offsetHeight + 8 : 0;
            var top = target.getBoundingClientRect().top + window.pageYOffset - offset;
            window.scrollTo({ top: top, behavior: 'smooth' });
          }
        }
      });
    });
  }

  /* ---- Init: Search ---- */
  function initSearch() {
    var searchInput = document.getElementById('podcast-hub-search');
    var nav = document.getElementById('podcast-hub-nav');
    if (!searchInput || !nav) return;

    var buttons = nav.querySelectorAll('.podcast-hub__nav-btn');
    var latestSection = document.getElementById('podcast-hub-latest');
    var debounceTimer;

    searchInput.addEventListener('input', function () {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(function () {
        var query = searchInput.value.toLowerCase().trim();

        /* Reset nav */
        buttons.forEach(function (b) { b.classList.remove('active'); });
        nav.querySelector('[data-filter="all"]').classList.add('active');

        var rows = document.querySelectorAll('.podcast-hub__row');

        /* Show everything first */
        rows.forEach(function (row) { row.classList.remove('hidden'); });
        if (latestSection) latestSection.style.display = '';

        if (!query) {
          /* Reset all cards */
          document.querySelectorAll('.podcast-hub__card').forEach(function (card) {
            if (!card.classList.contains('podcast-hub__card--hidden')) {
              card.style.display = '';
            }
          });
          document.querySelectorAll('.podcast-hub__rows .podcast-hub__card').forEach(function (card) {
            card.style.display = '';
          });
          rows.forEach(function (row) { row.classList.remove('hidden'); });

          /* Reset grid to full list */
          filteredLatest = allLatest;
          currentPage = 1;
          renderPage();
          return;
        }

        function doHeroSearch() {
          /* Filter the grid using the full dataset */
          filteredLatest = allLatest.filter(function (ep) {
            return (ep.title || '').toLowerCase().indexOf(query) !== -1 ||
                   (ep.desc || '').toLowerCase().indexOf(query) !== -1 ||
                   (String(ep.ep) || '').indexOf(query) !== -1;
          });
          currentPage = 1;
          renderPage();

          /* Filter carousel rows */
          var freshRows = document.querySelectorAll('.podcast-hub__row');
          freshRows.forEach(function (row) {
            var cards = row.querySelectorAll('.podcast-hub__card');
            var visibleCount = 0;

            cards.forEach(function (card) {
              var title = (card.querySelector('.podcast-hub__card-title') || {}).textContent || '';
              var meta = (card.querySelector('.podcast-hub__card-meta') || {}).textContent || '';
              var match = title.toLowerCase().indexOf(query) !== -1 || meta.toLowerCase().indexOf(query) !== -1;
              card.style.display = match ? '' : 'none';
              if (match) visibleCount++;
            });

            if (visibleCount === 0) {
              row.classList.add('hidden');
            }
          });
        }

        /* Load full dataset before searching */
        if (!fullDataLoaded && totalAvailable > initialEpisodeCount) {
          loadFullData(doHeroSearch);
        } else {
          doHeroSearch();
        }
      }, 200);
    });
  }

  /* (Show More and Browse Topics removed — replaced by pagination + inline search) */

  /* ==================================================================
     AUDIO PLAYER — Full-screen "Now Playing" overlay + mini bar
     Inspired by Spotify / Apple Podcasts
     ================================================================== */
  (function initAudioPlayer() {
    var CARD_IMG = window.__podcastCardImg || '';
    var audio = null;
    var miniEl = null;
    var overlayEl = null;
    var isBuilt = false;
    var activeCard = null;
    var isFading = false;
    var currentEpisode = { url: '', title: '', meta: '', desc: '' };

    /* Speed options */
    var speedOptions = [1, 1.25, 1.5, 2];
    var currentSpeedIdx = 0;
    try {
      var saved = parseFloat(localStorage.getItem('ph-playback-speed'));
      if (saved && speedOptions.indexOf(saved) !== -1) {
        currentSpeedIdx = speedOptions.indexOf(saved);
      }
    } catch (e) {}

    /* Sleep timer state */
    var sleepTimerOptions = [0, 15, 30, 45, -1]; // 0=off, -1=end of episode
    var sleepTimerLabels  = ['Off', '15 min', '30 min', '45 min', 'End of episode'];
    var sleepTimerIdx = 0;
    var sleepTimerId = null;
    var sleepEndOfEp = false;

    /* ---- SVG Icons ---- */
    var ICON_PLAY = '<svg viewBox="0 0 24 24" fill="currentColor"><polygon points="6,3 20,12 6,21"/></svg>';
    var ICON_PAUSE = '<svg viewBox="0 0 24 24" fill="currentColor"><rect x="5" y="3" width="4" height="18" rx="1"/><rect x="15" y="3" width="4" height="18" rx="1"/></svg>';
    var ICON_SKIP_FWD = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M23 4v6h-6"/><path d="M20.49 15a9 9 0 1 1-2.12-9.36L23 10"/><text x="12" y="16" text-anchor="middle" fill="currentColor" stroke="none" font-size="7" font-weight="700">15</text></svg>';
    var ICON_SKIP_BACK = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M1 4v6h6"/><path d="M3.51 15a9 9 0 1 0 2.12-9.36L1 10"/><text x="12" y="16" text-anchor="middle" fill="currentColor" stroke="none" font-size="7" font-weight="700">15</text></svg>';
    var ICON_CLOSE = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>';
    var ICON_HANDLE = '<span class="ph-np__handle-bar"></span>';
    var ICON_SPEED = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>';
    var ICON_SLEEP = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"/></svg>';
    var ICON_SHARE = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="18" cy="5" r="3"/><circle cx="6" cy="12" r="3"/><circle cx="18" cy="19" r="3"/><line x1="8.59" y1="13.51" x2="15.42" y2="17.49"/><line x1="15.41" y1="6.51" x2="8.59" y2="10.49"/></svg>';
    var ICON_EXTERNAL = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"/><polyline points="15 3 21 3 21 9"/><line x1="10" y1="14" x2="21" y2="3"/></svg>';

    /* ---- Slugify title for blog URL ---- */
    function slugify(str) {
      return (str || '').toLowerCase()
        .replace(/['']/g, '')
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-+|-+$/g, '');
    }
    function buildBlogUrl(ep, title) {
      if (!ep) return '';
      return '/blogs/news/' + ep + '-' + slugify(title);
    }

    /* ---- Format time ---- */
    function formatTime(sec) {
      if (!sec || isNaN(sec) || !isFinite(sec)) return '0:00';
      sec = Math.floor(sec);
      var h = Math.floor(sec / 3600);
      var m = Math.floor((sec % 3600) / 60);
      var s = sec % 60;
      if (h > 0) return h + ':' + (m < 10 ? '0' : '') + m + ':' + (s < 10 ? '0' : '') + s;
      return m + ':' + (s < 10 ? '0' : '') + s;
    }

    /* ---- Toast notification ---- */
    function showToast(msg) {
      var existing = document.getElementById('ph-toast');
      if (existing) existing.remove();
      var toast = document.createElement('div');
      toast.id = 'ph-toast';
      toast.className = 'ph-np__toast';
      toast.textContent = msg;
      document.body.appendChild(toast);
      requestAnimationFrame(function () {
        toast.classList.add('ph-np__toast--visible');
      });
      setTimeout(function () {
        toast.classList.remove('ph-np__toast--visible');
        setTimeout(function () { toast.remove(); }, 300);
      }, 2200);
    }

    /* ---- Build Mini Bar + Overlay ---- */
    function buildPlayer() {
      if (isBuilt) return;
      isBuilt = true;

      audio = new Audio();
      audio.preload = 'metadata';
      audio.playbackRate = speedOptions[currentSpeedIdx];

      /* --- Mini Bar --- */
      miniEl = document.createElement('div');
      miniEl.className = 'ph-mini';
      miniEl.id = 'ph-mini';
      miniEl.setAttribute('role', 'region');
      miniEl.setAttribute('aria-label', 'Audio player');
      miniEl.innerHTML =
        '<div class="ph-mini__progress"><div class="ph-mini__progress-fill" id="ph-mini-prog"></div></div>' +
        '<div class="ph-mini__inner">' +
          '<div class="ph-mini__info" id="ph-mini-info">' +
            '<img class="ph-mini__artwork" id="ph-mini-art" src="' + CARD_IMG + '" alt="">' +
            '<p class="ph-mini__title" id="ph-mini-title">\u2014</p>' +
          '</div>' +
          '<div class="ph-mini__controls">' +
            '<button class="ph-mini__play" id="ph-mini-play" aria-label="Play or pause"><span class="ph-mini__play-icon">' + ICON_PLAY + '</span></button>' +
            '<button class="ph-mini__close" id="ph-mini-close" aria-label="Close player">' + ICON_CLOSE + '</button>' +
          '</div>' +
        '</div>';
      document.body.appendChild(miniEl);

      /* --- Full Overlay --- */
      overlayEl = document.createElement('div');
      overlayEl.className = 'ph-np';
      overlayEl.id = 'ph-np';
      overlayEl.setAttribute('role', 'dialog');
      overlayEl.setAttribute('aria-label', 'Now Playing');
      overlayEl.innerHTML =
        '<div class="ph-np__scrim" id="ph-np-scrim"></div>' +
        '<div class="ph-np__panel">' +
          /* Header */
          '<button class="ph-np__collapse" id="ph-np-collapse" aria-label="Collapse player">' + ICON_HANDLE + '</button>' +
          '<div class="ph-np__header">' +
            '<span class="ph-np__header-label">Now Playing</span>' +
            '<button class="ph-np__close-overlay" id="ph-np-close-x" aria-label="Close player">' + ICON_CLOSE + '</button>' +
          '</div>' +
          /* Artwork */
          '<div class="ph-np__artwork-wrap">' +
            '<img class="ph-np__artwork" id="ph-np-art" src="' + CARD_IMG + '" alt="Podcast artwork">' +
          '</div>' +
          /* Title / subtitle */
          '<div class="ph-np__titles">' +
            '<h2 class="ph-np__title" id="ph-np-title">\u2014</h2>' +
            '<p class="ph-np__subtitle" id="ph-np-subtitle">Dr. Martin</p>' +
          '</div>' +
          /* Progress bar — native range input */
          '<div class="ph-np__progress-area">' +
            '<input type="range" id="ph-np-range" min="0" max="1000" value="0" style="width:100%;height:36px;accent-color:#92278f;cursor:pointer;">' +
            '<div class="ph-np__times">' +
              '<span class="ph-np__time" id="ph-np-time-cur">0:00</span>' +
              '<span class="ph-np__time" id="ph-np-time-dur">0:00</span>' +
            '</div>' +
          '</div>' +
          /* Main controls */
          '<div class="ph-np__controls">' +
            '<button class="ph-np__skip" id="ph-np-back" aria-label="Rewind 15 seconds">' + ICON_SKIP_BACK + '</button>' +
            '<button class="ph-np__play-btn" id="ph-np-play" aria-label="Play or pause"><span class="ph-np__play-icon">' + ICON_PLAY + '</span></button>' +
            '<button class="ph-np__skip" id="ph-np-fwd" aria-label="Forward 15 seconds">' + ICON_SKIP_FWD + '</button>' +
          '</div>' +
          /* Secondary controls */
          '<div class="ph-np__secondary">' +
            '<button class="ph-np__sec-btn" id="ph-np-speed" aria-label="Playback speed">' +
              '<span class="ph-np__sec-icon">' + ICON_SPEED + '</span>' +
              '<span class="ph-np__sec-label" id="ph-np-speed-label">' + speedOptions[currentSpeedIdx] + 'x</span>' +
            '</button>' +
            '<button class="ph-np__sec-btn" id="ph-np-sleep" aria-label="Sleep timer">' +
              '<span class="ph-np__sec-icon">' + ICON_SLEEP + '</span>' +
              '<span class="ph-np__sec-label" id="ph-np-sleep-label">Off</span>' +
            '</button>' +
            '<button class="ph-np__sec-btn" id="ph-np-share" aria-label="Share episode">' +
              '<span class="ph-np__sec-icon">' + ICON_SHARE + '</span>' +
              '<span class="ph-np__sec-label">Share</span>' +
            '</button>' +
          '</div>' +
          /* Episode description — hidden */
          /* View full episode link */
          '<a class="ph-np__episode-link" id="ph-np-episode-link" href="#" style="display:none;">' +
            '<span class="ph-np__episode-link-icon">' + ICON_EXTERNAL + '</span>' +
            '<span>View Full Episode</span>' +
          '</a>' +
        '</div>';
      document.body.appendChild(overlayEl);

      bindEvents();
    }

    /* ---- Bind all events ---- */
    function bindEvents() {
      var miniPlay = document.getElementById('ph-mini-play');
      var miniClose = document.getElementById('ph-mini-close');
      var miniInfo = document.getElementById('ph-mini-info');
      var npPlay = document.getElementById('ph-np-play');
      var npBack = document.getElementById('ph-np-back');
      var npFwd = document.getElementById('ph-np-fwd');
      var npCollapse = document.getElementById('ph-np-collapse');
      var npCloseX = document.getElementById('ph-np-close-x');
      var npScrim = document.getElementById('ph-np-scrim');
      var npSpeed = document.getElementById('ph-np-speed');
      var npSleep = document.getElementById('ph-np-sleep');
      var npShare = document.getElementById('ph-np-share');
      var npProgWrap = document.getElementById('ph-np-prog-wrap');

      /* --- Toggle play/pause --- */
      function togglePlay() {
        if (!audio.src) return;
        if (audio.paused) { audio.play(); } else { audio.pause(); }
      }
      miniPlay.addEventListener('click', function (e) { e.stopPropagation(); togglePlay(); });
      npPlay.addEventListener('click', togglePlay);

      /* --- Update play icons everywhere --- */
      function updatePlayIcons(playing) {
        var icon = playing ? ICON_PAUSE : ICON_PLAY;
        var miniIcon = miniEl.querySelector('.ph-mini__play-icon');
        var npIcon = overlayEl.querySelector('.ph-np__play-icon');
        if (miniIcon) miniIcon.innerHTML = icon;
        if (npIcon) npIcon.innerHTML = icon;
        if (playing) {
          overlayEl.classList.add('ph-np--playing');
        } else {
          overlayEl.classList.remove('ph-np--playing');
        }
      }
      audio.addEventListener('play', function () { updatePlayIcons(true); });
      audio.addEventListener('pause', function () { updatePlayIcons(false); });

      /* --- Skip --- */
      npBack.addEventListener('click', function () {
        audio.currentTime = Math.max(0, audio.currentTime - 15);
      });
      npFwd.addEventListener('click', function () {
        audio.currentTime = Math.min(audio.duration || 0, audio.currentTime + 15);
      });

      /* --- Progress updates --- */
      var npRange = document.getElementById('ph-np-range');
      var miniProg = document.getElementById('ph-mini-prog');
      var timeCur = document.getElementById('ph-np-time-cur');
      var timeDur = document.getElementById('ph-np-time-dur');
      var isSeeking = false;

      audio.addEventListener('timeupdate', function () {
        if (!audio.duration || isSeeking) return;
        var pct = (audio.currentTime / audio.duration) * 1000;
        npRange.value = pct;
        if (miniProg) miniProg.style.width = (pct / 10) + '%';
        timeCur.textContent = formatTime(audio.currentTime);
        timeDur.textContent = formatTime(audio.duration);
      });

      npRange.addEventListener('input', function () {
        isSeeking = true;
        if (audio.duration) {
          var t = (npRange.value / 1000) * audio.duration;
          timeCur.textContent = formatTime(t);
        }
      });
      npRange.addEventListener('change', function () {
        if (audio.duration) {
          audio.currentTime = (npRange.value / 1000) * audio.duration;
        }
        isSeeking = false;
      });

      /* --- Open overlay --- */
      var playerClosing = false; /* prevents mini-bar click from reopening after close */
      function openOverlay() {
        if (playerClosing) return;
        overlayEl.classList.add('ph-np--visible');
        document.body.style.overflow = 'hidden';
      }
      miniInfo.addEventListener('click', function (e) { e.stopPropagation(); openOverlay(); });
      /* Tap anywhere on mini bar (except buttons) */
      miniEl.addEventListener('click', function (e) {
        if (e.target.closest('.ph-mini__play') || e.target.closest('.ph-mini__close')) return;
        openOverlay();
      });

      /* --- Close everything — stop audio, hide all player UI instantly --- */
      function closePlayer() {
        playerClosing = true;
        /* Add closing class to skip animations — UI disappears immediately */
        overlayEl.classList.add('ph-np--closing');
        miniEl.classList.add('ph-mini--closing');
        overlayEl.classList.remove('ph-np--visible', 'ph-np--playing');
        miniEl.classList.remove('ph-mini--visible');
        document.body.style.overflow = '';
        audio.pause();
        audio.src = '';
        var hub = document.querySelector('.podcast-hub');
        if (hub) hub.classList.remove('podcast-hub--player-active');
        clearActiveCard();
        clearSleepTimer();
        currentEpisode = null;
        updatePlayIcons(false);
        /* Remove closing class and re-allow opening after current event cycle */
        setTimeout(function () {
          overlayEl.classList.remove('ph-np--closing');
          miniEl.classList.remove('ph-mini--closing');
          playerClosing = false;
        }, 50);
      }

      /* Handle bar = minimize to mini bar (keeps playing) */
      function minimizeOverlay() {
        overlayEl.classList.remove('ph-np--visible');
        document.body.style.overflow = '';
      }

      npCollapse.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); minimizeOverlay(); });
      npScrim.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); minimizeOverlay(); });

      /* X buttons = fully close and stop — mousedown fires before click to beat bubbling */
      miniClose.addEventListener('mousedown', function (e) { e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation(); closePlayer(); }, true);
      miniClose.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation(); }, true);
      npCloseX.addEventListener('mousedown', function (e) { e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation(); closePlayer(); }, true);
      npCloseX.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation(); }, true);
      /* Touch devices */
      miniClose.addEventListener('touchend', function (e) { e.preventDefault(); e.stopPropagation(); closePlayer(); }, { passive: false });
      npCloseX.addEventListener('touchend', function (e) { e.preventDefault(); e.stopPropagation(); closePlayer(); }, { passive: false });

      /* --- Speed --- */
      npSpeed.addEventListener('click', function () {
        currentSpeedIdx = (currentSpeedIdx + 1) % speedOptions.length;
        var spd = speedOptions[currentSpeedIdx];
        audio.playbackRate = spd;
        document.getElementById('ph-np-speed-label').textContent = spd + 'x';
        try { localStorage.setItem('ph-playback-speed', spd); } catch (e) {}
      });

      /* --- Sleep timer --- */
      npSleep.addEventListener('click', function () {
        sleepTimerIdx = (sleepTimerIdx + 1) % sleepTimerOptions.length;
        var val = sleepTimerOptions[sleepTimerIdx];
        document.getElementById('ph-np-sleep-label').textContent = sleepTimerLabels[sleepTimerIdx];

        clearSleepTimer();

        if (val > 0) {
          sleepTimerId = setTimeout(function () {
            audio.pause();
            showToast('Sleep timer ended');
            resetSleepTimerUI();
          }, val * 60 * 1000);
          npSleep.classList.add('ph-np__sec-btn--active');
        } else if (val === -1) {
          /* End of episode — handled in audio 'ended' event */
          sleepEndOfEp = true;
          npSleep.classList.add('ph-np__sec-btn--active');
        } else {
          npSleep.classList.remove('ph-np__sec-btn--active');
        }
      });

      /* --- Share --- */
      npShare.addEventListener('click', function () {
        var url = window.location.href;
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(url).then(function () {
            showToast('Copied!');
          });
        } else {
          /* Fallback */
          var ta = document.createElement('textarea');
          ta.value = url;
          ta.style.position = 'fixed';
          ta.style.left = '-9999px';
          document.body.appendChild(ta);
          ta.select();
          document.execCommand('copy');
          document.body.removeChild(ta);
          showToast('Copied!');
        }
      });

      /* --- Audio ended --- */
      audio.addEventListener('ended', function () {
        updatePlayIcons(false);
        if (sleepEndOfEp) {
          showToast('Sleep timer ended');
          resetSleepTimerUI();
        }
      });

      /* --- Keyboard shortcuts --- */
      document.addEventListener('keydown', function (e) {
        /* Escape closes overlay */
        if (e.key === 'Escape' && overlayEl.classList.contains('ph-np--visible')) {
          closePlayer();
          return;
        }
        if (!miniEl.classList.contains('ph-mini--visible')) return;
        var tag = (e.target.tagName || '').toLowerCase();
        if (tag === 'input' || tag === 'textarea' || tag === 'select') return;
        if (e.code === 'Space' || e.key === ' ') {
          e.preventDefault();
          togglePlay();
        }
      });
    }

    /* ---- Sleep timer helpers ---- */
    function clearSleepTimer() {
      if (sleepTimerId) { clearTimeout(sleepTimerId); sleepTimerId = null; }
      sleepEndOfEp = false;
    }
    function resetSleepTimerUI() {
      sleepTimerIdx = 0;
      clearSleepTimer();
      var label = document.getElementById('ph-np-sleep-label');
      var btn = document.getElementById('ph-np-sleep');
      if (label) label.textContent = 'Off';
      if (btn) btn.classList.remove('ph-np__sec-btn--active');
    }

    /* ---- Clear active card ---- */
    function clearActiveCard() {
      if (activeCard) {
        activeCard.classList.remove('podcast-hub__card--now-playing');
        var bars = activeCard.querySelector('.podcast-hub__now-playing-bars');
        if (bars) bars.remove();
        activeCard = null;
      }
    }

    /* ---- Mark card as now playing ---- */
    function markActiveCard(card) {
      clearActiveCard();
      if (!card) return;
      activeCard = card;
      card.classList.add('podcast-hub__card--now-playing');
      var thumb = card.querySelector('.podcast-hub__card-thumb');
      if (thumb && !thumb.querySelector('.podcast-hub__now-playing-bars')) {
        var bars = document.createElement('div');
        bars.className = 'podcast-hub__now-playing-bars';
        bars.innerHTML = '<span></span><span></span><span></span><span></span>';
        thumb.appendChild(bars);
      }
    }

    /* ---- Update overlay/mini UI with episode info ---- */
    function updateEpisodeUI(title, meta, desc, ep) {
      var npTitle = document.getElementById('ph-np-title');
      var npSub = document.getElementById('ph-np-subtitle');
      var npDesc = document.getElementById('ph-np-desc');
      var miniTitle = document.getElementById('ph-mini-title');
      var epLink = document.getElementById('ph-np-episode-link');

      if (npTitle) npTitle.textContent = title;
      if (npSub) npSub.textContent = meta || 'Dr. Martin';
      if (npDesc) npDesc.textContent = desc || '';
      if (miniTitle) miniTitle.textContent = title;

      /* Show/hide episode blog link */
      if (epLink) {
        var blogUrl = buildBlogUrl(ep, title);
        if (blogUrl) {
          epLink.href = blogUrl;
          epLink.style.display = '';
        } else {
          epLink.style.display = 'none';
        }
      }
    }

    /* ---- Load and play an episode ---- */
    function loadEpisode(url, title, meta, desc, card, ep) {
      buildPlayer();

      /* If same episode, just toggle */
      if (activeCard === card && !audio.paused) {
        audio.pause();
        return;
      }
      if (activeCard === card && audio.paused && audio.currentTime > 0) {
        audio.play();
        return;
      }

      currentEpisode = { url: url, title: title, meta: meta, desc: desc, ep: ep };

      /* Crossfade if currently playing */
      if (!audio.paused && audio.src && !isFading) {
        isFading = true;
        var fadeOut = setInterval(function () {
          if (audio.volume > 0.05) {
            audio.volume = Math.max(0, audio.volume - 0.1);
          } else {
            clearInterval(fadeOut);
            audio.pause();
            audio.volume = 1;
            isFading = false;
            startPlayback(url, title, meta, desc, card, ep);
          }
        }, 40);
        updateEpisodeUI(title, meta, desc, ep);
        markActiveCard(card);
        return;
      }

      startPlayback(url, title, meta, desc, card, ep);
    }

    function startPlayback(url, title, meta, desc, card, ep) {
      /* Reset progress */
      var npRange = document.getElementById('ph-np-range');
      var miniProg = document.getElementById('ph-mini-prog');
      var timeCur = document.getElementById('ph-np-time-cur');
      var timeDur = document.getElementById('ph-np-time-dur');

      if (npRange) npRange.value = 0;
      if (miniProg) miniProg.style.width = '0%';
      if (timeCur) timeCur.textContent = '0:00';
      if (timeDur) timeDur.textContent = '0:00';

      updateEpisodeUI(title, meta, desc, ep);

      /* Load & play */
      audio.src = url;
      audio.playbackRate = speedOptions[currentSpeedIdx];
      audio.play().catch(function (err) {
        console.warn('Podcast Hub Player: Autoplay blocked', err);
      });

      /* Show mini bar */
      miniEl.classList.add('ph-mini--visible');
      document.querySelector('.podcast-hub').classList.add('podcast-hub--player-active');

      markActiveCard(card);
    }

    /* ---- Intercept card clicks ---- */
    document.addEventListener('click', function (e) {
      var card = e.target.closest('.podcast-hub__card');
      if (!card) return;

      var audioUrl = card.getAttribute('data-audio');
      if (!audioUrl) return;

      e.preventDefault();
      e.stopPropagation();

      try {
        var title = card.getAttribute('data-title') || (card.querySelector('.podcast-hub__card-title') || {}).textContent || 'Podcast Episode';
        var meta = card.getAttribute('data-meta') || 'Dr. Martin';
        var desc = card.getAttribute('data-desc') || '';
        var ep = card.getAttribute('data-ep') || '';

        /* Build player first so audio + DOM elements exist */
        buildPlayer();
        loadEpisode(audioUrl, title, meta, desc, card, ep);

        /* Open the full overlay */
        overlayEl.classList.add('ph-np--visible');
        document.body.style.overflow = 'hidden';
      } catch (err) {
        console.error('Podcast Hub Player: Error on card click', err);
      }
    });

  })();

})();
